import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { environment } from '../../../environments/environment';

interface IndicatorRoom {
  id?: string;
  name?: string;
  sektion?: { id?: string; name?: string; gebaeude?: { id?: string; name?: string } };
}

interface IndicatorIndikator { id?: string | number; code?: string; }

export interface RoomIndikatorListItem {
  id: string;
  indikator_number?: number;
  system_id?: number;
  name: string;
  current_value?: string;
  einheit?: string;
  schwellenwert?: any;
  status?: number | boolean;
  room?: IndicatorRoom;
  indikator?: IndicatorIndikator;
}

@Component({
  selector: 'app-room-indikatoren-list',
  templateUrl: './room-indikatoren-list.component.html',
  styleUrls: ['./room-indikatoren-list.component.scss']
})
export class RoomIndikatorenListComponent implements OnChanges {
  @Input() standortId?: string;
  @Input() sektionId?: string;
  @Input() indicators: RoomIndikatorListItem[] = [];
  @Input() defaultStatus: 'Aktiv' | 'Inaktiv' | 'Alle' = 'Aktiv';

  @Output() editIndicator = new EventEmitter<RoomIndikatorListItem>();
  @Output() printIndicator = new EventEmitter<RoomIndikatorListItem>();
  @Output() printAll = new EventEmitter<void>();

  filtered: RoomIndikatorListItem[] = [];
  isStatusMenuOpen = false;
  selectedStatusFilter: number = 1; // 1 Aktiv, 0 Inaktiv, -1 Alle

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultStatus']) {
      this.selectedStatusFilter = this.defaultStatus === 'Inaktiv' ? 0 : (this.defaultStatus === 'Alle' ? -1 : 1);
    }
    this.applyFiltersAndSort();
  }

  toggleStatusMenu(): void { this.isStatusMenuOpen = !this.isStatusMenuOpen; }
  selectStatusFilter(val: number): void { this.selectedStatusFilter = val; this.isStatusMenuOpen = false; this.applyFiltersAndSort(); }
  getStatusFilterLabel(): string { return this.selectedStatusFilter === -1 ? 'Alle' : (this.selectedStatusFilter === 1 ? 'Aktiv' : 'Inaktiv'); }

  applyFiltersAndSort(): void {
    let items = Array.isArray(this.indicators) ? [...this.indicators] : [];
    // Sektion filter (if provided)
    if (this.sektionId) {
      items = items.filter(i => (i.room?.sektion?.id || '') === this.sektionId);
    }
    // Status filter
    if (this.selectedStatusFilter !== -1) {
      items = items.filter(i => Number(i.status) === this.selectedStatusFilter);
    }
    // Sort by Gebäude, Sektion, Room, Typ/Code, Name (case-insensitive)
    const ci = (v: any) => (v ?? '').toString().toLocaleLowerCase();
    items.sort((a, b) => {
      const ga = ci(a.room?.sektion?.gebaeude?.name);
      const gb = ci(b.room?.sektion?.gebaeude?.name);
      if (ga !== gb) return ga < gb ? -1 : 1;
      const sa = ci(a.room?.sektion?.name);
      const sb = ci(b.room?.sektion?.name);
      if (sa !== sb) return sa < sb ? -1 : 1;
      const ra = ci(a.room?.name);
      const rb = ci(b.room?.name);
      if (ra !== rb) return ra < rb ? -1 : 1;
      const ta = ci(a.indikator?.code);
      const tb = ci(b.indikator?.code);
      if (ta !== tb) return ta < tb ? -1 : 1;
      const na = ci(a.name);
      const nb = ci(b.name);
      if (na !== nb) return na < nb ? -1 : 1;
      return 0;
    });
    this.filtered = items;
  }

  getFormattedNumber(n?: number | null): string { if (n === null || n === undefined) return '-'; return n.toString().padStart(3, '0'); }
  getStatusBadgeClasses(s?: number | boolean): string { return (s === 1 || s === true) ? 'bg-green-100 text-green-800 ring-green-600/20' : 'bg-red-100 text-red-800 ring-red-600/20'; }
  getStatusText(s?: number | boolean): string { return (s === 1 || s === true) ? 'Aktiv' : 'Inaktiv'; }
  
  // Get symbol URL for indicator
  getIndicatorSymbolUrl(indicator: RoomIndikatorListItem): string | null {
    const symbolId = (indicator as any)?.indikator?.symbol_id || (indicator as any)?.symbol_id;
    if (!symbolId) return null;
    const key = (environment as any).indikatorSymbolMap?.[symbolId];
    if (!key) return null;
    const base = (environment as any).indikatorSymbolBasePath || '/assets/symbols';
    return `${base}/${key}.svg`;
  }
  
  // Get symbol color for indicator
  getIndicatorSymbolColor(indicator: RoomIndikatorListItem): string | null {
    const symbolId = (indicator as any)?.indikator?.symbol_id || (indicator as any)?.symbol_id;
    if (!symbolId) return null;
    const colorMap = (environment as any).indikatorSymbolColorMap || {};
    return colorMap[symbolId] || null;
  }
  
  // Format Schwellenwert as integer
  formatSchwellenwertAsInteger(schwellenwert: any): string {
    if (schwellenwert === null || schwellenwert === undefined || schwellenwert === '') {
      return '-';
    }
    const numValue = parseFloat(schwellenwert);
    if (isNaN(numValue)) {
      return schwellenwert.toString();
    }
    return Math.round(numValue).toString();
  }
}





